// extracted by mini-css-extract-plugin
module.exports = {"root":"buttons_root__wFpIv","stacked":"buttons_stacked__LAHpK","inline":"buttons_inline__TnQZo"};